import React from 'react'
import moment from 'moment'
import Swiper from 'react-id-swiper'
import Link from '../components/Link'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, withHandlers } from 'recompose'

import { get, getCount } from '../store/reducers/news'

const params = {
  effect: 'coverflow',
  grabCursor: true,
  centeredSlides: true,
  slidesPerView: 'auto',
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  coverflowEffect: {
    rotate: 0,
    stretch: 0,
    depth: 500,
    modifier: 1,
    slideShadows: false
  },
  breakpoints: {
    1024: {
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 300,
        modifier: 0.5,
        slideShadows: false
      }
    },
    667: {
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 0,
        slideShadows: false
      }
    }
  }
}

const NewsPage = ({ items = [] }) => {
  if (!items.length) return null

  return (
    <div className='Container News'>
      <Swiper {...params}>
        {items.map(el => (
          <Link to={`/news/${el._id}`} className='News__item' key={`news-${el._id}`}>
            <span className='News__item-body'>
              <span className='News__item-img-wrap'>
                <img className='News__item-img' src={el.image} alt={el.title} />
                <span className='News__item-img-overlay' />
              </span>
              <span className='News__item-caption'>
                <span className='News__item-label Text'>{moment(el.created).from(moment()).charAt(0).toUpperCase() + moment(el.created).from(moment()).slice(1)}</span>
                <h1 className='News__item-title'>{el.title}</h1>
              </span>
            </span>
          </Link>
        ))}
      </Swiper>
    </div>
  )
}

const mapStateToProps = state => ({ ...state.news })
const mapDispatchToProps = dispatch => bindActionCreators({ get, getCount }, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({}),
  lifecycle({
    componentWillMount () {
      this.props.get()
      this.props.getCount()
    }
  })
)(NewsPage)



// WEBPACK FOOTER //
// ./src/containers/News.jsx